import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";
import Main from "../modules/main/Main.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/",
    name: "Main",
    redirect: { name: "Home" },
    component: Main,
    children: [
      {
        path: "home/:code?",
        name: "Home",
        meta: { title: "Início" },
        component: () => import("@/modules/main/views/home/Home.vue"),
      },
      {
        path: "winners",
        name: "Winners",
        meta: { title: "Ganhadores" },
        component: () => import("@/modules/main/views/winners/Winners.vue"),
      },
      {
        path: "about",
        name: "About",
        meta: { title: "Sobre" },
        component: () => import("@/modules/main/views/about/About.vue"),
      },
      {
        path: "help",
        name: "Help",
        meta: { title: "Ajuda" },
        component: () => import("@/modules/main/views/help/Help.vue"),
      },
      {
        path: "terms",
        name: "Terms",
        meta: { title: "Termos" },
        component: () => import("@/modules/main/views/terms/Terms.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
